import React from 'react';

import type { Theme } from '@mui/material';

export type ThemeContextType = {
  appTheme: Theme;
  setCustomTheme: (theme: Partial<Theme>) => void;
  themeWasChanged: boolean;
  setThemeWasChanged: (themeWasChanged: boolean) => void;
};

export const ThemeContext = React.createContext({} as ThemeContextType);
